// Shown on every admin page when the API returns 403 — the staff member is
// signed in but lacks the service_admin role the admin routes require. One
// constant so the wording stays identical across the pages.
export const NOT_AUTHORIZED_MESSAGE =
  "You are not authorized to view this page. Ask an administrator if you need access."
